<template>
  <el-row class="penOrders">
    <el-row>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>工单搜索</span>
        </div>
        <div class="text item">
          <el-form :inline="true" ref="orderForm" :model="orderForm" size="small">
            <el-form-item label="输入查询" prop="sn">
              <el-input v-model="orderForm.sn" clearable placeholder="请输入工单号"></el-input>
            </el-form-item>
            <el-form-item label="产品型号" prop="goods_model">
              <el-select
                v-model="orderForm.goods_model"
                clearable
                filterable
                remote
                reserve-keyword
                placeholder="请输入型号关键词"
                :remote-method="remoteMethod"
                :loading="modelLoading">
                <el-option
                  v-for="item in modelOptions"
                  :key="item.id"
                  :label="item.model"
                  :value="item.model">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工单类型" prop="type">
              <el-select v-model="orderForm.type" clearable>
                <el-option v-for="item in datatype" :label="item.text" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间" prop="time">
              <el-date-picker v-model="orderForm.time" value-format="timestamp" format="yyyy 年 MM 月 dd 日" unlink-panels
                type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('orderForm')">查询</el-button>
              <el-button @click="resetForm('orderForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-divider></el-divider>
        <div class="tables">
          <div class="mains">
            <div class="">
              <el-table border :data="tableData" style="width: 100%">
                <el-table-column prop="sn" label="工单号">
                </el-table-column>
                <el-table-column prop="title" label="标题">
                </el-table-column>
                <el-table-column prop="goods_model" label="产品型号">
                </el-table-column>
                <el-table-column prop="type" label="工单类型">
                </el-table-column>
                <el-table-column prop="goods_category_name" label="所属部门">
                </el-table-column>
                <el-table-column prop="create_time" label="更新时间">
                </el-table-column>
                <el-table-column prop="status" label="状态">
                </el-table-column>
                <el-table-column prop="reminder_count" label="催单次数">
                </el-table-column>
                <el-table-column prop="create_person" label="工单发起人">
                </el-table-column>
                <el-table-column fixed="right" label="操作">
                  <template slot-scope="scope">
                    <el-button @click="lookOver(scope.row)" type="text" size="small">查看</el-button>
                    <el-button type="text" size="small">
                      <el-popconfirm confirm-button-text='是的' cancel-button-text='取消' icon="el-icon-info"
                        icon-color="#66b1ff" title="您确认受理该工单么？" @confirm="confirmEvent(scope.row)" @cancel="cancelEvent">
                        <el-button slot="reference" type="text" size="small">受理</el-button>
                      </el-popconfirm>
                    </el-button>
                    <!-- <el-button type="text" size="small">
                      <el-popconfirm confirm-button-text='是的' cancel-button-text='取消' icon="el-icon-info"
                        icon-color="#66b1ff" title="您确认退回该工单么？" @confirm="backClick(scope.row)" @cancel="cancelEvent">
                        <el-button slot="reference" type="text" size="small">退回</el-button>
                      </el-popconfirm>
                    </el-button> -->
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="pages">
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" @current-change="currentClick">
            </el-pagination>
          </div>
        </div>
      </el-card>
    </el-row>
  </el-row>
</template>

<script>
import { getOrderType, getOrderSearch, getOrderWait, getOrderAccept, orderBack,getWaitOrderSearch,modelSelect } from '../../utils/api'
export default {
  props: {},
  data() {
    return {
      page: 1,
      total: 0,
      pageSize:10,
      orderForm: {
        sn: '',
        type: '',
        time: '',
        goods_model:""
      },
      datatype: [],
      tableData: [],
      modelLoading:false,
      modelOptions:[]
    };
  },
  watch: {},
  computed: {},
  components: {},
  methods: {
    //获取工单类型
    getOrType() {
      var that = this
      that.datatype = []
      getOrderType()
        .then(res => {
          console.log(res, '工单');
          res.data.forEach(item => {
            that.datatype.push({ text: item.type, value: item.type })
          })
          console.log(that.datatype, 'type');
        })
    },

    //催单
    handleClick(row) {
      console.log(row);
    },
    //重置
    resetForm(form){
      this.$refs[form].resetFields()
    },
    //查看
    lookOver(row) {
      console.log(row, 'row');
      // this.$router.push('/pendOrderDetail?jumpId='+(row.id))
      this.$router.push('/orderDetail/orderDetail?jumpId='+(row.id))
    },
    //确认受理
    confirmEvent(row) {
      var that = this
      var params = {
        order_id: row.id
      }
      console.log(row, '确认');
      getOrderAccept(params)
        .then(res => {
          console.log(res, '受理');
          if (res.message.status == 'success') {
            that.$message.success(res.message.text)
            that.getOrders()
          } else {
            that.$message.error(res.message.text)
          }
        })
        .catch(err => {
          console.log(err, 'err');
        })
    },
    //取消受理
    cancelEvent() {
      console.log('取消了');
    },
    //退回工单
    backClick(row) {
      console.log('退回');
      var that = this
      var params = {
        order_id: row.id
      }
      orderBack(params)
        .then(res => {
          if(res.message.status == 'success'){
              that.$message.success(res.message.text)
              that.getOrders()
          }else{
              that.$message.error(res.message.text)
          }
        })
        .catch(err => {
          console.log(err, 'err');
        })
    },
    //待受理工单
    getOrders() {
      var that = this
      var params = {
        page: that.page,
        pagesize: that.pageSize
      }
      getOrderWait(params)
        .then(res => {
          console.log(res, '待受理工单');
          if(res.message.status == 'success'){
            that.tableData = res.data
            that.getStatus(that.tableData)
            that.total = res.total
          }else{
            that.tableData = []
          }
        })
        .catch(err => {
          console.log(err, 'err');
        })
    },
    //当前页
    currentClick(e) {
      var that = this
      that.page = e
      if (that.orderForm.sn !== '' || that.orderForm.type !== '' || (that.orderForm.time !== null && that.orderForm.time !== '')) {
        that.submitForm()
      } else {
        that.getOrders()
      }
      console.log(that.orderForm, 'orderForm');
    },
    //查询
    submitForm() {
      var that = this
      var times = that.orderForm.time
      if(times == ''){
        times = null
      }
      if(Array.isArray(times) && times[0] === ''){
        times = null
      }
      var params = {
        page: that.page,
        pagesize: that.pageSize,
        depart_id: '',
        sn: that.orderForm.sn,
        type: that.orderForm.type,
        goods_model:that.orderForm.goods_model,
        begin_time: times == null?'':times[0] / 1000,
        end_time: times == null?'':times[1] / 1000
      }
      getWaitOrderSearch(params)
        .then(res => {
          console.log(res, 'res');
          if (res.message.status == 'success') {
            that.tableData = res.data
            that.getStatus(that.tableData)
            that.total = res.total
          }else{
            that.tableData = []
            that.total = 0
          }
        })
        .catch(err => {
          console.log(err, 'err');
        })
    },
    //型号模糊查询触发
    remoteMethod(value){
      console.log('促发了');
      this.modelOptions = []
      if(value !== ''){
        this.modelLoading = true;
        var params = {
          model:value
        }
        modelSelect(params)
        .then(res=>{
          console.log(res,'模糊查询结果');
          if(res.message.status == 'success'){
            this.modelOptions = res.data
            this.modelLoading = false
          }else{
            this.modelLoading = false
            this.$message.error(res.message.text)
          }
        })
        .catch(err=>{
          this.$message.error(err)
          this.modelLoading = false
          console.log(err);
        })
      }else{
        this.modelOptions = []
      }
    },


  },
  created() { },
  mounted() {
  },
  activated() {
    this.getOrType()
    this.getOrders()
    this.submitForm()
  }

};
</script>
<style lang="scss" scoped>
.pages {
  text-align: right;
}
</style>